import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { csvFields } from '../../data/vendoo';
import { EASE_OUT } from '../../utils/motion';
type ExportState = 'idle' | 'preparing' | 'done';
export function CsvExportMock() {
  const [selected, setSelected] = useState<string[]>(csvFields.slice(0, 6));
  const [state, setState] = useState<ExportState>('idle');
  const timer = useRef<number>();
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const toggle = (field: string) => {
    setState('idle');
    setSelected(prev => prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]);
  };
  const runExport = () => {
    setState('preparing');
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setState('done'), 600);
  };
  return <div className="grid place-items-center rounded-2xl bg-surface px-4 py-10 md:py-14" data-id="element-600" data-mp="3otx52oalixc">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-sm md:p-6" data-id="element-601" data-mp="1xtis17390hd0">
        <div className="flex items-baseline justify-between" data-id="element-602" data-mp="22rkcnwgbooql">
          <h3 className="text-base font-semibold text-fg" data-id="element-603" data-mp="22ty2nqw5bara">Export inventory</h3>
          <span className="text-xs tabular-nums text-fg-faint" data-id="element-604" data-mp="26rvt0x1nk2w9">412 items</span>
        </div>
        <p className="mt-1 text-xs text-fg-muted" data-id="element-605" data-mp="2btbcwls3g3d2">Choose the columns to include in your CSV.</p>

        <fieldset className="mt-5" data-id="element-606" data-mp="2gqtqwqkyx8rx">
          <legend className="sr-only" data-id="element-607" data-mp="2gpscqd8no65z">Columns</legend>
          <div className="grid grid-cols-2 gap-2" data-id="element-608" data-mp="2lpo7rmzdkn9e">
            {csvFields.map(field => {
            const checked = selected.includes(field);
            return <label key={field} className={`flex cursor-pointer items-center gap-2.5 rounded-lg border px-3 py-2 text-xs font-medium transition-colors duration-150 ${checked ? 'border-ink/30 bg-ink-soft/60 text-ink' : 'border-line text-fg-muted hover:border-ink/20'}`} data-id="element-609" data-mp="2ujjcitwl4boi">
                  <input type="checkbox" checked={checked} onChange={() => toggle(field)} className="sr-only" data-id="element-610" data-mp="14cli1qsvtked" />
                  <span className={`grid h-4 w-4 shrink-0 place-items-center rounded transition-colors duration-150 ${checked ? 'bg-ink text-white' : 'border border-line bg-white'}`} data-id="element-611" data-mp="1e4r9mzf81zt1">
                    {checked && <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-612" data-mp="1n7il2z83kvko" />}
                  </span>
                  {field}
                </label>;
          })}
          </div>
        </fieldset>

        <button type="button" onClick={runExport} disabled={selected.length === 0 || state === 'preparing'} className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-ink py-2.5 text-sm font-medium text-white transition-[background-color,transform] duration-150 ease-out hover:bg-ink-deep active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60" data-id="element-613" data-mp="1x199630bb3zu">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-614" data-mp="2eco5uso4kvxr">
            <motion.span key={state} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: EASE_OUT
          }} className="inline-flex items-center gap-2" data-id="element-615" data-mp="2ef0n13m2729r">
              {state === 'done' ? <CheckIcon className="h-4 w-4" data-id="element-616" data-mp="1vmzgdf31m7ps" /> : <DownloadIcon className="h-4 w-4" data-id="element-617" data-mp="1vn7u196zph21" />}
              {state === 'idle' && `Export ${selected.length} columns`}
              {state === 'preparing' && 'Preparing file…'}
              {state === 'done' && 'inventory.csv downloaded'}
            </motion.span>
          </AnimatePresence>
        </button>
        <p aria-live="polite" className="sr-only" data-id="element-618" data-mp="3b3zwun2akc42">
          {state === 'done' ? 'Export complete' : ''}
        </p>
      </div>
    </div>;
}